import Routing from "../Routing";
import "../stylesheets/global.scss";

function App() {
  return <Routing />;
}

export default App;
